import { isTypeSimpleColumnSection } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulSimpleColumnSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeSimpleColumnSection(entry)) {
    return null;
  }

  return <div>ContentfulSimpleColumnSection</div>;
};

export default ContentfulSimpleColumnSection;
